"use strict";
/**
 * WARNING: This file is auto-generated
 *
 * DO NOT UPDATE MANUALLY!
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  __schema: {
    queryType: {
      name: 'Query'
    },
    mutationType: {
      name: 'Mutation'
    },
    subscriptionType: null,
    types: [{
      kind: 'OBJECT',
      name: 'AcceptTermsPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'me',
        type: {
          kind: 'OBJECT',
          name: 'User',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'AdvancedRegistrationsUsage',
      fields: [{
        name: 'included',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'used',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'AppsumoRegistrationsUsage',
      fields: [{
        name: 'includedFree',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'includedPaid',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'usedFree',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'usedPaid',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'UNION',
      name: 'AttendeesStats',
      possibleTypes: [{
        kind: 'OBJECT',
        name: 'BaseAttendeesStats'
      }, {
        kind: 'OBJECT',
        name: 'EssentialsAttendeesStats'
      }]
    }, {
      kind: 'OBJECT',
      name: 'BaseAttendeesStats',
      fields: [{
        name: 'name',
        type: {
          kind: 'SCALAR',
          name: 'Int',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'BaseRegistrationsUsage',
      fields: [{
        name: 'name',
        type: {
          kind: 'SCALAR',
          name: 'Int',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'SCALAR',
      name: 'Boolean'
    }, {
      kind: 'SCALAR',
      name: 'DateTime'
    }, {
      kind: 'SCALAR',
      name: 'Decimal'
    }, {
      kind: 'INTERFACE',
      name: 'DisplayableError',
      fields: [{
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [],
      possibleTypes: [{
        kind: 'OBJECT',
        name: 'EventDeleteError'
      }, {
        kind: 'OBJECT',
        name: 'EventDuplicateError'
      }, {
        kind: 'OBJECT',
        name: 'EventRegistrantUpdateTicketError'
      }, {
        kind: 'OBJECT',
        name: 'EventSpeakerCreateError'
      }, {
        kind: 'OBJECT',
        name: 'EventSpeakerRegisterError'
      }, {
        kind: 'OBJECT',
        name: 'EventSpeakerUpdateError'
      }, {
        kind: 'OBJECT',
        name: 'EventStageSetupRtmpError'
      }, {
        kind: 'OBJECT',
        name: 'OrganizationCreateError'
      }, {
        kind: 'OBJECT',
        name: 'OrganizationMemberEventAccessUpdateError'
      }, {
        kind: 'OBJECT',
        name: 'OrganizationMemberInvitationAcceptError'
      }, {
        kind: 'OBJECT',
        name: 'OrganizationMemberInvitationCancelError'
      }, {
        kind: 'OBJECT',
        name: 'OrganizationMemberInvitationRejectError'
      }, {
        kind: 'OBJECT',
        name: 'OrganizationMemberInvitationSendError'
      }, {
        kind: 'OBJECT',
        name: 'OrganizationMemberRemoveError'
      }, {
        kind: 'OBJECT',
        name: 'OrganizationMemberRoleUpdateError'
      }, {
        kind: 'OBJECT',
        name: 'OrganizationUpdateError'
      }, {
        kind: 'OBJECT',
        name: 'PaymentPlanSeatRemoveError'
      }, {
        kind: 'OBJECT',
        name: 'SavedEventAddUserError'
      }, {
        kind: 'OBJECT',
        name: 'SavedEventRemoveUserError'
      }, {
        kind: 'OBJECT',
        name: 'StripeUnlinkAccountError'
      }, {
        kind: 'OBJECT',
        name: 'UserChangeEmailError'
      }, {
        kind: 'OBJECT',
        name: 'UserChangePasswordError'
      }, {
        kind: 'OBJECT',
        name: 'UserDeleteError'
      }, {
        kind: 'OBJECT',
        name: 'UserUpdateError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'DuplicatableEventSection',
      fields: [{
        name: 'availability',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'DuplicatableEventSectionAvailability',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'name',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'DuplicatableEventSectionAvailability',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'SCALAR',
      name: 'EmailAddress'
    }, {
      kind: 'OBJECT',
      name: 'EssentialsAttendeesStats',
      fields: [{
        name: 'eventAttendeesAllowance',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'eventCountAboveAllowance',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'eventCountBelowAllowance',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'Event',
      fields: [{
        name: 'canBeDuplicated',
        type: {
          kind: 'SCALAR',
          name: 'Boolean',
          ofType: null
        },
        args: []
      }, {
        name: 'createdAt',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'deletable',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }, {
        name: 'description',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'duplicatableEventSections',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'OBJECT',
              name: 'DuplicatableEventSection',
              ofType: null
            }
          }
        },
        args: []
      }, {
        name: 'eventKind',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'expired',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'host',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Host',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'image',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'isLite',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'logo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'name',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'organizationMembersWithAccess',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'EventOrganizationMemberConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'organizationMembersWithoutAccess',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'EventOrganizationMemberConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'priceRange',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'EventPriceRange',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'registrants',
        type: {
          kind: 'OBJECT',
          name: 'EventRegistrantConnection',
          ofType: null
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'registrationPageUrl',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Url',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'registrationsCount',
        type: {
          kind: 'SCALAR',
          name: 'Int',
          ofType: null
        },
        args: []
      }, {
        name: 'slug',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'speaker',
        type: {
          kind: 'OBJECT',
          name: 'EventSpeaker',
          ofType: null
        },
        args: [{
          name: 'speakerId',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'ID',
              ofType: null
            }
          }
        }]
      }, {
        name: 'speakers',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'EventSpeakerConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'stage',
        type: {
          kind: 'OBJECT',
          name: 'Stage',
          ofType: null
        },
        args: [{
          name: 'stageUuid',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'ID',
              ofType: null
            }
          }
        }]
      }, {
        name: 'stages',
        type: {
          kind: 'OBJECT',
          name: 'StageConnection',
          ofType: null
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'status',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }, {
        name: 'tickets',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'TicketConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'timeEnd',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'timeStart',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'timeZone',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'updatedAt',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'venueType',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventDeleteError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'EventDeletePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'deletedId',
        type: {
          kind: 'SCALAR',
          name: 'ID',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventDeleteError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventDuplicateError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'EventDuplicatePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'newEvent',
        type: {
          kind: 'OBJECT',
          name: 'Event',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventDuplicateError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'Event',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventOrganizationMemberConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventOrganizationMemberEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventOrganizationMemberEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'eventAccess',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }, {
        name: 'joinedAt',
        type: {
          kind: 'SCALAR',
          name: 'DateTime',
          ofType: null
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationMember',
          ofType: null
        },
        args: []
      }, {
        name: 'role',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventPriceRange',
      fields: [{
        name: 'maxTicketPrice',
        type: {
          kind: 'OBJECT',
          name: 'Money',
          ofType: null
        },
        args: []
      }, {
        name: 'minTicketPrice',
        type: {
          kind: 'OBJECT',
          name: 'Money',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventRegistrant',
      fields: [{
        name: 'bio',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'blocked',
        type: {
          kind: 'SCALAR',
          name: 'Boolean',
          ofType: null
        },
        args: []
      }, {
        name: 'email',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'EmailAddress',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'firstName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'headline',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'image',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'lastName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'linkedinUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'refunded',
        type: {
          kind: 'SCALAR',
          name: 'Boolean',
          ofType: null
        },
        args: []
      }, {
        name: 'twitterUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'websiteUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventRegistrantConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventRegistrantEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventRegistrantEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'EventRegistrant',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventRegistrantProfile',
      fields: [{
        name: 'email',
        type: {
          kind: 'SCALAR',
          name: 'EmailAddress',
          ofType: null
        },
        args: []
      }, {
        name: 'firstName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'headline',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'image',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'lastName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'linkedinUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'twitterUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'websiteUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventRegistrantProfileConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventRegistrantProfileEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventRegistrantProfileEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'EventRegistrantProfile',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventRegistrantUpdateTicketError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'EventRegistrantUpdateTicketPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'eventRegistrant',
        type: {
          kind: 'OBJECT',
          name: 'EventRegistrant',
          ofType: null
        },
        args: []
      }, {
        name: 'ticket',
        type: {
          kind: 'OBJECT',
          name: 'Ticket',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventRegistrantUpdateTicketError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSchedule',
      fields: [{
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'isDraft',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'sessions',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'EventSessionConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'timeEnd',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'timeStart',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'timeZone',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSession',
      fields: [{
        name: 'attendance',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'capacity',
        type: {
          kind: 'SCALAR',
          name: 'Int',
          ofType: null
        },
        args: []
      }, {
        name: 'description',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'isDraft',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'name',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'remainingCapacity',
        type: {
          kind: 'SCALAR',
          name: 'Int',
          ofType: null
        },
        args: []
      }, {
        name: 'sessionFormat',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }, {
        name: 'speakers',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'EventSpeakerConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'timeEnd',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'timeStart',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSessionConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventSessionEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSessionEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'EventSession',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSpeaker',
      fields: [{
        name: 'bio',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'email',
        type: {
          kind: 'SCALAR',
          name: 'EmailAddress',
          ofType: null
        },
        args: []
      }, {
        name: 'firstName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'headline',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'image',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'lastName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'linkedinUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'registrationStatus',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'twitterUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'websiteUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSpeakerConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventSpeakerEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSpeakerCreateError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'EventSpeakerCreateFromRegistrantPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'eventSpeaker',
        type: {
          kind: 'OBJECT',
          name: 'EventSpeaker',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventSpeakerCreateError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSpeakerCreatePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'eventSpeaker',
        type: {
          kind: 'OBJECT',
          name: 'EventSpeaker',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventSpeakerCreateError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSpeakerDeletePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'deletedId',
        type: {
          kind: 'SCALAR',
          name: 'ID',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSpeakerEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'EventSpeaker',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSpeakerRegisterError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'EventSpeakerRegisterPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'eventSpeaker',
        type: {
          kind: 'OBJECT',
          name: 'EventSpeaker',
          ofType: null
        },
        args: []
      }, {
        name: 'magicLink',
        type: {
          kind: 'OBJECT',
          name: 'MagicLink',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventSpeakerRegisterError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventSpeakerUpdateError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'EventSpeakerUpdatePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'eventSpeaker',
        type: {
          kind: 'OBJECT',
          name: 'EventSpeaker',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventSpeakerUpdateError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'EventStageSetupRtmpError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'FreeRegistrationsUsage',
      fields: [{
        name: 'includedPerEvent',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'Host',
      fields: [{
        name: 'about',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'facebookUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'name',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'picture',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'twitterUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'websiteUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'SCALAR',
      name: 'ID'
    }, {
      kind: 'OBJECT',
      name: 'Image',
      fields: [{
        name: 'url',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: [{
          name: 'imgixParams',
          type: {
            kind: 'SCALAR',
            name: 'JSON',
            ofType: null
          }
        }]
      }],
      interfaces: []
    }, {
      kind: 'SCALAR',
      name: 'Int'
    }, {
      kind: 'SCALAR',
      name: 'JSON'
    }, {
      kind: 'OBJECT',
      name: 'MagicLink',
      fields: [{
        name: 'createdAt',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'email',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'EmailAddress',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'event',
        type: {
          kind: 'OBJECT',
          name: 'Event',
          ofType: null
        },
        args: []
      }, {
        name: 'firstName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'headline',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'lastName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'status',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }, {
        name: 'ticket',
        type: {
          kind: 'OBJECT',
          name: 'Ticket',
          ofType: null
        },
        args: []
      }, {
        name: 'updatedAt',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'url',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'Money',
      fields: [{
        name: 'amount',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Decimal',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'currencyCode',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'Mutation',
      fields: [{
        name: 'eventDelete',
        type: {
          kind: 'OBJECT',
          name: 'EventDeletePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'eventDuplicate',
        type: {
          kind: 'OBJECT',
          name: 'EventDuplicatePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'eventRegistrantUpdateTicket',
        type: {
          kind: 'OBJECT',
          name: 'EventRegistrantUpdateTicketPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'eventSpeakerCreate',
        type: {
          kind: 'OBJECT',
          name: 'EventSpeakerCreatePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'eventSpeakerCreateFromRegistrant',
        type: {
          kind: 'OBJECT',
          name: 'EventSpeakerCreateFromRegistrantPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'eventSpeakerDelete',
        type: {
          kind: 'OBJECT',
          name: 'EventSpeakerDeletePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'eventSpeakerRegister',
        type: {
          kind: 'OBJECT',
          name: 'EventSpeakerRegisterPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'eventSpeakerUpdate',
        type: {
          kind: 'OBJECT',
          name: 'EventSpeakerUpdatePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'organizationCreate',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationCreatePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'organizationMemberEventAccessBulkUpdateAll',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationMemberEventAccessBulkUpdateAllPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'organizationMemberEventAccessUpdate',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationMemberEventAccessUpdatePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'organizationMemberInvitationAccept',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationInvitationAcceptPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'organizationMemberInvitationCancel',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationMemberInvitationCancelPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'organizationMemberInvitationReject',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationInvitationRejectPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'organizationMemberInvitationSend',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationMemberInvitationSendPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'organizationMemberRemove',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationMemberRemovePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'organizationMemberRoleUpdate',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationMemberRoleUpdatePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'organizationUpdate',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationUpdatePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'paymentPlanSeatRemove',
        type: {
          kind: 'OBJECT',
          name: 'PaymentPlanSeatRemovePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'savedEventAdd',
        type: {
          kind: 'OBJECT',
          name: 'SavedEventAddPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'savedEventRemove',
        type: {
          kind: 'OBJECT',
          name: 'SavedEventRemovePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'stageSetupRtmp',
        type: {
          kind: 'OBJECT',
          name: 'StageSetupRTMPPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'stripeUnlinkAccount',
        type: {
          kind: 'OBJECT',
          name: 'StripeUnlinkAccountPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'userAcceptTerms',
        type: {
          kind: 'OBJECT',
          name: 'AcceptTermsPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'userChangeEmail',
        type: {
          kind: 'OBJECT',
          name: 'UserChangeEmailPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'userChangePassword',
        type: {
          kind: 'OBJECT',
          name: 'UserChangePasswordPayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'userConnectionDelete',
        type: {
          kind: 'OBJECT',
          name: 'UserConnectionDeletePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'userDelete',
        type: {
          kind: 'OBJECT',
          name: 'UserDeletePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }, {
        name: 'userUpdate',
        type: {
          kind: 'OBJECT',
          name: 'UserUpdatePayload',
          ofType: null
        },
        args: [{
          name: 'input',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'Any'
            }
          }
        }]
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'Organization',
      fields: [{
        name: 'about',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'coverImage',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'createdAt',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'email',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'EmailAddress',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'events',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'EventConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'facebookUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'features',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'OrganizationFeatures',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'hasReachedOrganiserLimit',
        type: {
          kind: 'SCALAR',
          name: 'Boolean',
          ofType: null
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'image',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'memberInvitations',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationInvitationConnection',
          ofType: null
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'members',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationMemberConnection',
          ofType: null
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'name',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'ownerId',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'paymentPlan',
        type: {
          kind: 'OBJECT',
          name: 'PaymentPlan',
          ofType: null
        },
        args: []
      }, {
        name: 'pendingMemberInvitationsCount',
        type: {
          kind: 'SCALAR',
          name: 'Int',
          ofType: null
        },
        args: []
      }, {
        name: 'twitterUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'updatedAt',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'websiteUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'UserOrganizationEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationCreateError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'OrganizationCreatePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'organization',
        type: {
          kind: 'OBJECT',
          name: 'Organization',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OrganizationCreateError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationFeatures',
      fields: [{
        name: 'eventsLite',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'eventsPro',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'rolesAndPermissions',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationInvitation',
      fields: [{
        name: 'email',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'EmailAddress',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'organization',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Organization',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'role',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'status',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationInvitationAcceptPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'invitation',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationInvitation',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OrganizationMemberInvitationAcceptError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationInvitationConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OrganizationInvitationEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationInvitationEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationInvitation',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationInvitationRejectPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'invitation',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationInvitation',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OrganizationMemberInvitationRejectError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMember',
      fields: [{
        name: 'bio',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'email',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'EmailAddress',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'firstName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'image',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'lastName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OrganizationMemberEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'joinedAt',
        type: {
          kind: 'SCALAR',
          name: 'DateTime',
          ofType: null
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationMember',
          ofType: null
        },
        args: []
      }, {
        name: 'role',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberEventAccessBulkUpdateAllPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'eventAccess',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberEventAccessUpdateError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberEventAccessUpdatePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'eventAccess',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }, {
        name: 'organizationMember',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationInvitation',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OrganizationMemberEventAccessUpdateError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberInvitationAcceptError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberInvitationCancelError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberInvitationCancelPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'invitation',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationInvitation',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OrganizationMemberInvitationCancelError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberInvitationRejectError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberInvitationSendError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberInvitationSendPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'invitation',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationInvitation',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OrganizationMemberInvitationSendError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberRemoveError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberRemovePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'removedMemberId',
        type: {
          kind: 'SCALAR',
          name: 'ID',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OrganizationMemberRemoveError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberRoleUpdateError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'OrganizationMemberRoleUpdatePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'organizationMember',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationMember',
          ofType: null
        },
        args: []
      }, {
        name: 'role',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OrganizationMemberRoleUpdateError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'OrganizationUpdateError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'OrganizationUpdatePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'organization',
        type: {
          kind: 'OBJECT',
          name: 'Organization',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'OrganizationUpdateError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'PageInfo',
      fields: [{
        name: 'endCursor',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'hasNextPage',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'hasPreviousPage',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'startCursor',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'PaymentPlan',
      fields: [{
        name: 'attendeesStats',
        type: {
          kind: 'UNION',
          name: 'AttendeesStats',
          ofType: null
        },
        args: []
      }, {
        name: 'hasActiveSubscription',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'hasEventsLite',
        type: {
          kind: 'SCALAR',
          name: 'Boolean',
          ofType: null
        },
        args: []
      }, {
        name: 'hasEventsPro',
        type: {
          kind: 'SCALAR',
          name: 'Boolean',
          ofType: null
        },
        args: []
      }, {
        name: 'includedRegistrations',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'includedSeats',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'isAppsumo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'isSelfserve',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'isSpecial',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'isStripeMigrationEnabled',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'name',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'paidTicketsAllowed',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'pricing',
        type: {
          kind: 'OBJECT',
          name: 'PaymentPlanPricing',
          ofType: null
        },
        args: []
      }, {
        name: 'registrationsUsage',
        type: {
          kind: 'UNION',
          name: 'RegistrationsUsage',
          ofType: null
        },
        args: []
      }, {
        name: 'seats',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PaymentPlanSeats',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'usedSeats',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'PaymentPlanPricing',
      fields: [{
        name: 'interval',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }, {
        name: 'price',
        type: {
          kind: 'OBJECT',
          name: 'Money',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'PaymentPlanSeatRemoveError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'PaymentPlanSeatRemovePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'paymentPlan',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PaymentPlan',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PaymentPlanSeatRemoveError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'PaymentPlanSeats',
      fields: [{
        name: 'additional',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'additionalSeatPrice',
        type: {
          kind: 'OBJECT',
          name: 'Money',
          ofType: null
        },
        args: []
      }, {
        name: 'included',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'total',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'usedAdditional',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'usedIncluded',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'usedTotal',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'Query',
      fields: [{
        name: 'event',
        type: {
          kind: 'OBJECT',
          name: 'Event',
          ofType: null
        },
        args: [{
          name: 'id',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'ID',
              ofType: null
            }
          }
        }]
      }, {
        name: 'eventBySlug',
        type: {
          kind: 'OBJECT',
          name: 'Event',
          ofType: null
        },
        args: [{
          name: 'slug',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        }]
      }, {
        name: 'eventSchedule',
        type: {
          kind: 'OBJECT',
          name: 'EventSchedule',
          ofType: null
        },
        args: [{
          name: 'eventId',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'ID',
              ofType: null
            }
          }
        }]
      }, {
        name: 'me',
        type: {
          kind: 'OBJECT',
          name: 'User',
          ofType: null
        },
        args: []
      }, {
        name: 'organization',
        type: {
          kind: 'OBJECT',
          name: 'Organization',
          ofType: null
        },
        args: [{
          name: 'id',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'ID',
              ofType: null
            }
          }
        }]
      }],
      interfaces: []
    }, {
      kind: 'UNION',
      name: 'RegistrationsUsage',
      possibleTypes: [{
        kind: 'OBJECT',
        name: 'AdvancedRegistrationsUsage'
      }, {
        kind: 'OBJECT',
        name: 'AppsumoRegistrationsUsage'
      }, {
        kind: 'OBJECT',
        name: 'BaseRegistrationsUsage'
      }, {
        kind: 'OBJECT',
        name: 'FreeRegistrationsUsage'
      }, {
        kind: 'OBJECT',
        name: 'SelfServeRegistrationsUsage'
      }]
    }, {
      kind: 'OBJECT',
      name: 'SavedEventAddPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'event',
        type: {
          kind: 'OBJECT',
          name: 'Event',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'SavedEventAddUserError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'SavedEventAddUserError',
      fields: [{
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'SavedEventRemovePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'event',
        type: {
          kind: 'SCALAR',
          name: 'ID',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'SavedEventRemoveUserError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'SavedEventRemoveUserError',
      fields: [{
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'SelfServeRegistrationsUsage',
      fields: [{
        name: 'accrued',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'available',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'included',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'used',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'Stage',
      fields: [{
        name: 'chatId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'name',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'uuid',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'videoChannels',
        type: {
          kind: 'OBJECT',
          name: 'VideoChannelConnection',
          ofType: null
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'StageConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'StageEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'StageEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'Stage',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'StageSetupRTMPPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'stage',
        type: {
          kind: 'OBJECT',
          name: 'Stage',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'EventStageSetupRtmpError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'SCALAR',
      name: 'String'
    }, {
      kind: 'OBJECT',
      name: 'StripeUnlinkAccountError',
      fields: [{
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'StripeUnlinkAccountPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'unlinkedOrganizationId',
        type: {
          kind: 'SCALAR',
          name: 'ID',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'StripeUnlinkAccountError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'Ticket',
      fields: [{
        name: 'accessType',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'availability',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'description',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'name',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'price',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Money',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'pricingType',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'remainingCapacity',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'TicketConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'TicketEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'TicketEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'Ticket',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'SCALAR',
      name: 'Url'
    }, {
      kind: 'OBJECT',
      name: 'User',
      fields: [{
        name: 'bio',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'createdAt',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'deleteConfirmationPhrase',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'email',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'EmailAddress',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'emailConfirmedAt',
        type: {
          kind: 'SCALAR',
          name: 'DateTime',
          ofType: null
        },
        args: []
      }, {
        name: 'firstName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'hasAcceptedTerms',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'headline',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'image',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'lastName',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'linkedinUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'organizationInvitations',
        type: {
          kind: 'OBJECT',
          name: 'OrganizationInvitationConnection',
          ofType: null
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'organizations',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'OrganizationConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'recommendedEvents',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'UserEventConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }]
      }, {
        name: 'registeredEvent',
        type: {
          kind: 'OBJECT',
          name: 'Event',
          ofType: null
        },
        args: [{
          name: 'eventId',
          type: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'ID',
              ofType: null
            }
          }
        }]
      }, {
        name: 'registeredEvents',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'UserEventConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'savedEvents',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'UserEventConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'twitterUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }, {
        name: 'unconfirmedEmail',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'updatedAt',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'DateTime',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'vendorBooths',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'VendorBoothConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'query',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'websiteUrl',
        type: {
          kind: 'SCALAR',
          name: 'Url',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'UserChangeEmailError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'UserChangeEmailPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'me',
        type: {
          kind: 'OBJECT',
          name: 'User',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'UserChangeEmailError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'UserChangePasswordError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'UserChangePasswordPayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'me',
        type: {
          kind: 'OBJECT',
          name: 'User',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'UserChangePasswordError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'UserConnectionDeletePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'deletedRegistrantId',
        type: {
          kind: 'SCALAR',
          name: 'ID',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'UserDeleteError',
      fields: [{
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'UserDeletePayload',
      fields: [{
        name: 'bye',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'deletedId',
        type: {
          kind: 'SCALAR',
          name: 'ID',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'UserDeleteError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'UserEventConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'UserEventEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'UserEventEdge',
      fields: [{
        name: 'connections',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'EventRegistrantProfileConnection',
            ofType: null
          }
        },
        args: [{
          name: 'after',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'before',
          type: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        }, {
          name: 'first',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'last',
          type: {
            kind: 'SCALAR',
            name: 'Int',
            ofType: null
          }
        }, {
          name: 'reverse',
          type: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        }, {
          name: 'sortKey',
          type: {
            kind: 'SCALAR',
            name: 'Any'
          }
        }]
      }, {
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'isSaved',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Boolean',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'Event',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'SCALAR',
      name: 'UserFileUploadS3TempUrl'
    }, {
      kind: 'OBJECT',
      name: 'UserOrganizationEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'joinedAt',
        type: {
          kind: 'SCALAR',
          name: 'DateTime',
          ofType: null
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'Organization',
          ofType: null
        },
        args: []
      }, {
        name: 'role',
        type: {
          kind: 'SCALAR',
          name: 'Any'
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'UserUpdateError',
      fields: [{
        name: 'code',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'message',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'path',
        type: {
          kind: 'LIST',
          ofType: {
            kind: 'NON_NULL',
            ofType: {
              kind: 'SCALAR',
              name: 'String',
              ofType: null
            }
          }
        },
        args: []
      }],
      interfaces: [{
        kind: 'INTERFACE',
        name: 'DisplayableError'
      }]
    }, {
      kind: 'OBJECT',
      name: 'UserUpdatePayload',
      fields: [{
        name: 'clientMutationId',
        type: {
          kind: 'SCALAR',
          name: 'String',
          ofType: null
        },
        args: []
      }, {
        name: 'me',
        type: {
          kind: 'OBJECT',
          name: 'User',
          ofType: null
        },
        args: []
      }, {
        name: 'userErrors',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'UserUpdateError',
                ofType: null
              }
            }
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'VendorBooth',
      fields: [{
        name: 'about',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'coverImage',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'email',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'EmailAddress',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'event',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Event',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'headline',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'id',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'ID',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'image',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'Image',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'name',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'VendorBoothConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'VendorBoothEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'VendorBoothEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'VendorBooth',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'VideoChannel',
      fields: [{
        name: 'priority',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'Any'
          }
        },
        args: []
      }, {
        name: 'streamKey',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'streamUrl',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'VideoChannelConnection',
      fields: [{
        name: 'edges',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'LIST',
            ofType: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'VideoChannelEdge',
                ofType: null
              }
            }
          }
        },
        args: []
      }, {
        name: 'pageInfo',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'OBJECT',
            name: 'PageInfo',
            ofType: null
          }
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'OBJECT',
      name: 'VideoChannelEdge',
      fields: [{
        name: 'cursor',
        type: {
          kind: 'NON_NULL',
          ofType: {
            kind: 'SCALAR',
            name: 'String',
            ofType: null
          }
        },
        args: []
      }, {
        name: 'node',
        type: {
          kind: 'OBJECT',
          name: 'VideoChannel',
          ofType: null
        },
        args: []
      }],
      interfaces: []
    }, {
      kind: 'SCALAR',
      name: 'Any'
    }],
    directives: []
  }
};